export class OrgChartMessages {
  public static readonly RESTRICTED_TITLE = 'org-chart.restricted.title';
  public static readonly RESTRICTED_BODY = 'org-chart.restricted.body';
}
